<template>
  <!--我的页面-->
  <tk-container
    :status="status"
    @scroll="watchScroll"
    infiniteScroll
    hide-status-bar
    class="my-happy-bean-bg"
    :style="{background: bgColor, backgroundImage: `url(${bgSrc}) !important`}"
    @refresh="refreshInit"
    @loadingMore="geHappyBeanRecords"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true" :is-header-color="isHeaderColor" :back-style="false" :icon-name="'fanhui'">
      <div slot="center-menu" :style="{ color: isHeaderColor ? '#000000' : '#fff' + '!important', zIndex: zIndex }">我的欢乐豆</div>
    </gradient-header>
    <!--背景图渲染-->
    <div class="bean-page-bg">
      <!--欢乐豆数量显示-->
      <tk-flex center column class="p-x-12 bean-page-bg-star">
        <tk-flex middle center class="m-t-10 font-14 page-bg-star-space">
          当前 <span class="font-32 font-bold">{{' ' + happyBeanSum + ' '}}</span>个
          <tk-image :replacement="false" class="m-l-5" :src="beanImage" width="25" height="25"></tk-image>
        </tk-flex>
        <div class="m-t-10 font-12">订单满100元可得，会员级别越高，满百得豆越多</div>
        <tk-flex
          right middle
          class="full-width m-t-20 font-12"
          @click.native="nextShopping"
        >
          去逛逛 <tk-icon size="11" class="m-l-5" color="rgba(245, 245, 245, 1)">rightarrow</tk-icon>
        </tk-flex>
      </tk-flex>
      <!--收支明细-->
      <div class="m-x-12 m-t-10 p-y-15 record-card b-g-f">
        <tk-flex slot="header" center class="font-bold p-y-20">收支明细</tk-flex>
        <div v-if="happyBeanRecords.length" class="m-x-12">
          <card
            :width="100"
            :height="65"
            class="p-0"
            v-for="(s, index) in happyBeanRecords"
            :key="index"
          >
            <tk-flex
              middle
              between
              class="p-12"
            >
              <div class="full-width tk-grid-9">
                <div class="font-14 van-ellipsis">{{s.access}}</div>
                <div class="caption m-t-10">{{s.createdAt | datetime}}</div>
              </div>
              <tk-flex middle class="tk-grid-3" right wrap>
                <div class="primary font-bold">
                  {{s.revenue === 'income' ? '+' + s.number : '-' + s.number}}
                </div>
                <tk-avatar size="22" class="m-l-5" color="rgba(247, 200, 75, 1)">
                  <div class="star-image">
                    <tk-image class="m-b-4" :src="'https://s3.moke.cloud/dianpei/d75beba6-9b75-4e3d-9928-dd46d2b2dad4.png'" width="12" height="12"></tk-image>
                  </div>
                </tk-avatar>
              </tk-flex>
            </tk-flex>
          </card>
        </div>
      </div>
    </div>
  </tk-container>
</template>

<script>
import { List } from 'vant'
let beanImage = 'https://s3.moke.cloud/dianpei/91905c22-8a93-472f-aaec-e72401df3a69.png' // 欢乐豆图片
export default {
  components: {
    [List.name]: List
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      wallet: null, // 钱包数据
      beanImage: beanImage, // 欢乐豆图片
      happyBeanRecords: [] // 欢乐豆收支明细
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      return 'https://s3.moke.cloud/dianpei/0c349e26-05f7-441d-b17c-85829f4928e6.png'
    },
    // 背景颜色
    bgColor () {
      return '#f5f5f5'
    },
    // 欢乐豆数量
    happyBeanSum () {
      if (!this.wallet || (this.wallet && !this.wallet.happyBean)) { return 0 }
      return this.wallet.happyBean
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/8
     */
    async getInit () {
      try {
        await this.getWallet() // 获取用户钱包
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.happyBeanRecords = []
      await this.getInit()
      this.$refs.resetMyHappyBean.resetInfiniteScroll()
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 获取用户钱包
     * @date: 2020/4/11
     */
    async getWallet () {
      let wallet = await this.$tkParse.getList('/classes/wallet', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (wallet.length) { this.wallet = wallet[0] } else { this.wallet = null }
    },
    /**
    * 去逛逛
    * @date: 2020/4/28
    */
    nextShopping () {
      this.$cleanHistory()
      this.$replace('/')
    },
    /**
    * 欢乐豆明细的无限加载
    * @date: 2020/4/28
    */
    async geHappyBeanRecords (page, next) {
      let happyBeanRecords = await this.$tkParse.getList(`/classes/happyBeanRecords`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-createdAt',
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      this.happyBeanRecords = [...this.happyBeanRecords, ...happyBeanRecords]
      if (happyBeanRecords.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .my-happy-bean-bg {
    width: 100%;
    min-height: 230px;
    background-repeat: no-repeat !important;
    background-size: 100% 230px !important;
    background-attachment: fixed !important;
  }
  /*背景图样式*/
  .bean-page-bg {
    width: 100%;
    padding-top: 60px;
    .bean-page-bg-star {
      color: #fff;
      .page-bg-star-space {
        margin-left: 10px;
        letter-spacing: 3px;
      }
    }
    .record-card {
      border-radius: 5px;
      background: #fff;
    }
    .star-image {
      width: 12px;
      height: 12px;
    }
  }
</style>
